@if (background() && !alternate()) {
  <svg
    class="background-md d-lg-none"
    viewBox="0 0 393 425"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 0V424.443H393V70.1689L104.734 127.486C75.7738 133.245 46.8283 117.519 35.8983 90.0898L0 0Z"
      [style.fill]="'var(--trix-background-basic-color-2)'"
    />
    <path
      d="M131 424.443L0 116.443V424.443H131Z"
      [style.fill]="'var(--trix-background-basic-color-1)'"
    />
  </svg>
  <svg
    class="background d-none d-lg-block"
    viewBox="0 0 1366 1024"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1366 -836.78L-13.9999 -836.78L-13.9999 -836.776H-14V1616.56H1366L1366 606.469L1366 -836.78ZM1366 606.469L224.707 832.401C195.848 838.114 166.957 822.716 155.61 795.574L-13.9999 389.886L-13.9999 -836.776H1366L1366 606.469Z"
      [style.fill]="'var(--trix-background-basic-color-2)'"
    />
    <path
      d="M302.208 1299.67L-3.89746 570.273V1299.67H302.208Z"
      [style.fill]="'var(--trix-background-basic-color-1)'"
    />
  </svg>
}

@if (background() && alternate()) {
  <svg
    class="background d-lg-none"
    viewBox="0 0 393 425"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="393"
      height="150"
      [style.fill]="'var(--trix-background-basic-color-1)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 13.160156 34.597656 L 0 5.414062 L 0 111 C 48.296875 110.066406 129.570312 91.839844 233.398438 70.921875 C 316.460938 54.1875 360.882812 79.382812 377.675781 93.171875 L 393 106.494141 L 393 0 C 377.921875 5.462891 177.207031 35.923828 114.277344 44.328125 C 51 52.777344 24.683594 27.625 13.160156 34.597656 Z M 13.160156 34.597656 "
      d="M 13.160156 18.390625 L 0 2.878906 L 0 118 C 48.296875 117.007812 129.570312 97.628906 233.398438 75.394531 C 316.460938 57.605469 360.882812 84.386719 377.675781 99.046875 L 393 113.210938 L 393 0 C 377.921875 5.808594 177.207031 38.191406 114.277344 47.125 C 51 56.105469 24.683594 29.367188 13.160156 18.390625 Z M 13.160156 18.390625 "
      [style.fill]="'var(--trix-background-basic-color-2)'"
      transform="translate(0, 100)"
    />
  </svg>
  <svg
    class="background d-none d-lg-block"
    viewBox="0 0 1366 1024"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="1366"
      height="540"
      [style.fill]="'var(--trix-background-basic-color-1)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.5 72L0 11.2683V462C213.653 458.118 533.816 382.25 963.524 295.188C1221.85 225.539 1300.3 330.401 1366 387.795L1366 443.248V0C1280.31 22.7358 672.201 149.522 369 184.5C164.683 219.67 79.7071 114.976 42.5 72Z"
      [style.fill]="'var(--trix-background-basic-color-2)'"
      transform="translate(0, 320)"
    />
  </svg>
}
<div class="content-container">
  <div class="content" [class.content-max-width]="maxWidth()">
    <ng-content />
  </div>
</div>
